const addQueryParam = (url: string, newParam: string) => {
    const hasQueryString = url.indexOf('?') > -1;
    return url + (hasQueryString ? '&' : '?') + newParam;
};

export default addQueryParam;
